<template>
    <custom-table
        :title="$t('pages.company.domain.title')"
        :subTitle="$t('pages.company.domain.subTitle')"
        rowKey="id"
        :items="domains"
        :loading="false"
        :columns="fields"
        :actions="actions"
        changeUrlPage
        @action="handleClickAction"
        @changeTable="handleTableChange">
        <template v-slot:domain="{ row: record }">
            {{ record.domain }}
        </template>
        <template v-slot:is_default="{ row: record }">
            <span :class="record.is_default ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.is_default ? $t('common.yes') : $t('common.no') }}</span>
        </template>
        <template v-slot:active="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.detail')" placement="top">
                    <a v-on:click="fetchRecord(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/general/gen004.svg"/>
                     </span>
                    </a>
                </el-tooltip>

                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_user_label" ref="labelModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_add_customer_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="labelForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.company.domain.cols.domain') }}</label>
                                <el-form-item prop="domain" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.domain" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.domain.cols.isDefault') }}</label>
                                <el-form-item prop="status">
                                    <el-radio-group v-model="form.data.is_default">
                                        <el-radio-button :label="true">{{ $t("common.yes") }}</el-radio-button>
                                        <el-radio-button :label="false">{{ $t("common.no") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.domain.cols.active') }}</label>
                                <el-form-item prop="status">
                                    <el-radio-group v-model="form.data.active">
                                        <el-radio-button :label="true">{{ $t("common.active") }}</el-radio-button>
                                        <el-radio-button :label="false">{{ $t("common.passive") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    props: ['domains', 'companyID', 'showUserBackButton'],
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.company.domain.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.company.domain.cols.domain"),
                    scopedSlots: {customRender: "domain"},
                },
                {
                    name: this.$t("pages.company.domain.cols.isDefault"),
                    scopedSlots: {customRender: "is_default"}
                },
                {
                    name: this.$t("pages.company.domain.cols.active"),
                    scopedSlots: {customRender: "active"},
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    computed: {},
    created() {
    },
    mounted() {

    },
    methods: {
        refreshTable() {
            this.$emit("refresh");
        },
        newRecord() {
            this.form.updateStatus = false;
            this.form.data = {
                company_id: this.companyID,
                is_default: false,
                active: true
            };
            this.form.title = this.$t("pages.company.domain.newDomain");

            this.showModal(this.$refs.labelModal);
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("company/domain/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
        fetchRecord(record) {
            this.form.updateStatus = true;
            this.form.title = this.$t("pages.company.domain.editDomain");
            this.axios.get(this.endpoints['company_domain'] + '/' + record.id).then(response => {
                let data = response.data.data;
                this.form.data = data;

                this.showModal(this.$refs.labelModal);
            });
        },
        onSubmit() {
            this.$refs.labelForm.validate((valid) => {
                if (valid) {
                    let formData = this.prepareFormData();
                    this.form.loading = true;

                    if (formData.id) {
                        this.axios.put(this.endpoints['company_domain'] + '/' + this.form.data.id, formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.labelModal);
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data);
                        }).finally(() => {
                            this.form.loading = false;
                        });
                    } else {
                        this.axios.post(this.endpoints['company_domain'], formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.labelModal);
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data);
                        }).finally(() => {
                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        prepareFormData() {
            let formData = this.cloneData(this.form.data);

            return formData
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.newRecord();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },

        handleTableChange(pagination, filterData) {
            this.refreshTable()
        },
    }
}
</script>

<style>
.order-page-header:after {
    content: "";
    clear: both;
    display: table;
}
</style>